<template>
  <CustomDeleteDialog
    :dialogTitle="`حذف مدیر زبان ${
      defaultLanguageManager ? defaultLanguageManager.language.persianTitle : ''
    }`"
    dialogId="delete-language-manager-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteLanguageManagerRequest"
  >
    <p>
      آیا از حذف مدیر زبان
      <strong>
        {{
          defaultLanguageManager
            ? defaultLanguageManager.language.persianTitle
            : ""
        }}
      </strong>
      اطمینان دارید؟
    </p>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultLanguageManager: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteLanguageManagerRequest() {
      try {
        this.isOkButtonDisabled = true;
        const _this = this;
        const deleteALanguageManager = new DeleteALanguageManager(_this);
        deleteALanguageManager.setRequestParam({
          languageManagerId: _this.defaultLanguageManager.id,
        });
        await deleteALanguageManager.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "مدیر زبان با موفقیت حذف شد.",
              },
            });
            this.$bvModal.hide("delete-language-manager-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import { DeleteALanguageManager } from "@/libs/Api/LanguageManagers";
</script>
